import { attach } from 'effector';

import { api } from '@shared/api/api';

const loginFx = attach({ effect: api.auth.loginInit });

export { loginFx };
